var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.856 23.448-4.622 4.883a1.073 1.073 0 0 1-.786.337H2.537a.543.543 0 0 1-.493-.318.522.522 0 0 1 .1-.573l4.626-4.882a1.075 1.075 0 0 1 .783-.336h21.91a.543.543 0 0 1 .493.317.52.52 0 0 1-.1.57zm-4.622-9.833a1.072 1.072 0 0 0-.786-.336H2.537a.542.542 0 0 0-.493.317.522.522 0 0 0 .1.571l4.626 4.883a1.075 1.075 0 0 0 .783.337h21.91a.543.543 0 0 0 .493-.318.52.52 0 0 0-.1-.572l-4.622-4.883zM2.537 10.108h21.911a1.087 1.087 0 0 0 .786-.336l4.622-4.883a.525.525 0 0 0-.393-.89H7.553a1.087 1.087 0 0 0-.783.336L2.145 9.219a.526.526 0 0 0 .392.888z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/SOL.99148eb63c97bf4d48e2d9117681b7bf.svg";
export { ForwardRef as ReactComponent };